import classNames from 'classnames';
import { checkIfSSR } from 'helpers/checkIfSSR';
import { signIn } from 'next-auth/react';
import { ArticleText, Button, Container } from 'ui/components';
import styles from "./LoginFeature.module.scss"

export const LoginFeature: React.FC<Umbraco.ArticleText> = ({ content }) => {
	let callBackUrl = process.env.NEXTAUTH_URL;
	if (!checkIfSSR) {
		callBackUrl = window.location.origin;
	}

	return (
		<div>
			<Container width="Standard">
				<div className="u-bottom-margin--xl">
					<ArticleText {...content?.properties} />
				</div>
				<div className={classNames("u-grid__cell u-grid__cell--width-100", styles.Login__button)}>
					<Button onClick={() => signIn('authServer', { callBackUrl: callBackUrl })}>Log ind</Button>
				</div>
			</Container>
		</div>
	);
};
